import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import FileIcon from '@material-ui/icons/Description';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../AppContext';
import PropTypes from 'prop-types';
import { DynamicForm } from './DynamicForm';

// SERVICES
import { updateOrderLineServices } from '../../services';

const styles = theme => ({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    '& > *': {
      alignSelf: 'stretch',
    },
  },
  dialogTitle: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  dialogActions: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  cancelButton: {
    color: '#f44336',
  },
  removeButton: {
    color: '#f44336',
  },
  circularProgress: {
    padding: '6px 8px',
  },
  reportAttachmentList: {
    paddingLeft: 0,
    listStyle: 'none',
  },
  reportAttachmentListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  fileLink: {
    display: 'flex',
    flexDirection: 'row',
  },
  uploadButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  errorMessage: { color: '#c33' },

  costTable: {
    width: '100%',

    '& td': {
      flex: 1,
      textAlign: 'left',
    },

    '& tr': {
      marginBottom: 10,
    },

    '& th': {
      textAlign: 'center',
      fontWeight: 'bold',
    },

    '& > tr > *': {
      padding: 20,
    },
  },

  tableInput: {
    border: '1px solid #ccc',
    borderRadius: 5,
    padding: 10,
    fontSize: 16,
    color: '#777',

    '&:focus': {
      outline: 'none',
    },
  },
});

export const DynamicFormModal = withStyles(styles)(props => {
  const { classes, modalVisible, hideModal, modalChildType, modalLabel } = props;

  return !modalVisible ? null : (
    <React.Fragment>
      <Dialog maxWidth="lg" open={modalVisible} onClose={hideModal} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
          {modalLabel}
        </DialogTitle>
        <DialogContent>
          {modalChildType === 'input' && <DynamicForm {...props} />}
          {/* {
          modalChildType === 'show' &&
          <FormShow { ...props } />
        } */}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button color="secondary" onClick={hideModal}>
            Dismiss
          </Button>
          {/* <Button color="primary" onClick={saveFees} disabled={submitting || loading}>
            Save Updates
          </Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

DynamicFormModal.propTypes = {
  classes: PropTypes.object.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalLabel: PropTypes.string,

  modalChildType: PropTypes.oneOf(['input', 'show']),
};

DynamicFormModal.defaultProps = {
  modalChildType: 'input',
};
